import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';
import useNotificationActionHandler from '@/common/notifications/useNotificationActionHandler.ts';
import { useEffect, useState } from 'react';

export const notificationActionSearch = z.object({
  actionId: z.string().optional(),
  href: z.coerce.string().optional(),
});

export const Route = createFileRoute('/notification/action')({
  validateSearch: notificationActionSearch,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();

  return (
    <NotificationActionExecutor
      actionId={search.actionId}
      href={search.href}
    />
  );
}

export function NotificationActionExecutor({
  actionId,
  href,
}: {
  actionId?: string;
  href?: string;
}) {
  const actionHandler = useNotificationActionHandler();
  const [handled, setHandled] = useState(false);

  useEffect(() => {
    if (actionId === undefined || href === undefined) {
      setHandled(false);
      return;
    }

    setHandled(actionHandler(actionId, href));
  }, [actionHandler, actionId, href]);

  if (!handled) {
    return null;
  }

  return <Navigate to={'/'} />;
}
